import { usePickupModals } from "@redotech/redo-customer-portal-shared/hooks/useReturnConfirmation/use-pickup-modals";
import Calendar from "@redotech/redo-icons/calendar.svg";
import XClose from "@redotech/redo-icons/x-close.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export const PickupButtons = memo(function PickupButtons({
  pickupModals,
}: {
  pickupModals: ReturnType<typeof usePickupModals>;
}) {
  const { setRescheduleModalOpen, setCancelModalOpen } = pickupModals;

  return (
    <Flex flexDirection="row" gap="sm" grow={1} pt="xs">
      <RedoButton
        hierarchy="secondary"
        IconLeading={Calendar}
        onClick={() => setRescheduleModalOpen(true)}
        text="Reschedule pickup"
      />
      <RedoButton
        hierarchy="secondary"
        IconLeading={XClose}
        onClick={() => setCancelModalOpen(true)}
        text="Cancel pickup"
      />
    </Flex>
  );
});
